import { Component, Input } from '@angular/core';
import { TabData } from '@ddt-web/data-service';

@Component({
	selector: 'dl-tooltip-section-header',
	templateUrl: './tooltip-section-header.component.html',
	styleUrls: ['./tooltip-section-header.component.scss']
})

export class TooltipSectionHeaderComponent {
	@Input() public tab: TabData;
}
